import React, { useState } from 'react';
import ObservationFeed from '../components/observations/ObservationFeed';
import AskPanel from '../components/observations/AskPanel';

// Insights (2026-10 restyle): everything that moved, biggest first, and a way
// to ask about any of it. The ask card sits at the top like the Log page's
// capture card; asking is still a full-screen session you enter deliberately.

const PROMPTS = ['How has my sleep been lately?', 'Has this happened before?', 'What changed after I started magnesium?'];

const MicIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-[22px] w-[22px]" aria-hidden="true">
    <rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0" /><path d="M12 18v3" />
  </svg>
);
const UpIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-[22px] w-[22px]" aria-hidden="true">
    <path d="M12 19V5" /><path d="M5 12l7-7 7 7" />
  </svg>
);

const InsightsPage = () => {
  // null | { context: observation|null, text, voice }
  const [ask, setAsk] = useState(null);

  return (
    <div className="mx-auto max-w-[1080px] px-4 sm:px-6 lg:px-10">
      <div className="mb-[22px]">
        <h1 className="text-[1.75rem] font-medium leading-[1.15] tracking-[-0.02em]">Insights</h1>
        <p className="mt-1 max-w-[40em] text-fg-3">Everything that moved, biggest first. Tap one to see why.</p>
      </div>

      <div className="rounded-[18px] border border-line bg-raised p-4 sm:p-5">
        <div className="flex min-h-[60px] items-center gap-3 rounded-full border border-line-strong bg-canvas py-1.5 pl-5 pr-1.5">
          <button type="button" onClick={() => setAsk({ context: null, text: '' })} className="min-w-0 flex-1 truncate bg-transparent p-0 text-left text-[1.1rem] text-fg-3 hover:text-fg-2">
            Ask about you…
          </button>
          <button type="button" onClick={() => setAsk({ context: null, text: '', voice: true })} aria-label="Talk"
            className="grid h-12 w-12 flex-none place-items-center rounded-full border border-line-strong bg-transparent text-fg hover:bg-elev">
            <MicIcon />
          </button>
          <button type="button" onClick={() => setAsk({ context: null, text: '' })} aria-label="Type a question"
            className="grid h-12 w-12 flex-none place-items-center rounded-full bg-cta text-cta-fg hover:bg-cta-hover">
            <UpIcon />
          </button>
        </div>
        <div className="mt-3.5 flex flex-wrap items-center gap-2">
          <em className="mr-1 text-sm not-italic text-fg-3">Try:</em>
          {PROMPTS.map((p) => (
            <button key={p} type="button" onClick={() => setAsk({ context: null, text: p })}
              className="rounded-full border border-line-strong bg-transparent px-3.5 py-2 text-sm text-fg-2 hover:bg-elev hover:text-fg">
              {p}
            </button>
          ))}
        </div>
      </div>

      <ObservationFeed onAsk={(item) => setAsk({ context: item, text: '' })} />

      <AskPanel
        key={ask ? `${ask.context?.id || 'general'}-${ask.text}` : 'closed'}
        open={!!ask}
        context={ask?.context || null}
        initialText={ask?.text || ''}
        startVoice={!!ask?.voice}
        onClose={() => setAsk(null)}
      />
    </div>
  );
};

export default InsightsPage;
